import React from 'react';

const UserOffCanvasHeader = ({func}) => {
    return (
        <div className=" text-white flex flex-row justify-between p-2 items-start ">
            <div className=" ">
                <div className={` text-3xl `}>My Account</div>
                <div className={` text-lg `}>Update your photo and personal details</div>
            </div>

            <div
                className={` hidden cursor-pointer text-xl sm:flex flex-row gap-4 p-2 items-center hover:opacity-60 transition-opacity duration-300`}
                onClick={() => func()}>
                <i className=" text-2xl ri-close-line text-gold-accent "></i>
                <div>Close</div>
            </div>
        </div>
    );
};

export default UserOffCanvasHeader;